import { ChevronRightList } from '@arvesta-websites/icons';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';

import Media from '../../../../utils/Media';

interface StyledTitleProps {
  inColumn?: boolean;
}

export const CardTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.heading};
  color: ${({ theme }) => theme.colors.primaryWhite};
  font-weight: 700;
  filter: drop-shadow(1px 1px 0px #0000004d);

  ${Media({
    fontSize: ['22px', '22px', '28px', '28px'],
    lineHeight: ['27px', null, '27px', '45px'],
  })}
`;

export const StyledChevron = styled(ChevronRightList)`
  align-self: flex-end;
  color: #f8faf2;

  ${Media({
    height: [null, null, null, '32px'],
    width: [null, null, null, '32px'],
  })}

  path {
    transition: all 0.3s;
  }
`;

export const StyledImage = styled(GatsbyImage)`
  left: 0;
  top: 0;
  object-fit: cover;
  transition: all 0.3s ease-in-out;
  position: absolute !important;
  height: 100% !important;
  width: 100% !important;
  box-shadow: 3px 3px 3px #00000029;
`;

export const TitleWrapper = styled(Box)<StyledTitleProps>`
  height: 100%;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
  position: relative;

  ${props =>
    Media({
      minHeight: props.inColumn ? ['100px', '100px', '200px', '200px'] : ['100px', null, null, '200px'],
      padding: ['0.75rem', '1rem 1.2rem', null, '0.75rem 1.5rem'],
    })}}
`;

export const Gradient = styled(Box)`
  transition: all 0.3s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: transparent linear-gradient(0deg, #00000000 0%, #00000080 100%) 0% 0% no-repeat padding-box;
`;

export const CardWrapper = styled.div`
  position: relative;
  box-shadow: 3px 3px 3px #00000029;
  overflow: hidden;

  &:hover {
    text-decoration: none;
    font-weight: normal;
  }
`;
